export const allowedISODateFormats = ['yyyy-LL-dd', 'yy-LL-dd', 'yy-L-d', 'yyyy-L-d'];
export const allowedISODateFormatsWithoutDay = ['yyyy-LL', 'yy-LL', 'yyyy-L', 'yy-L'];
export const RANGE_START = 'rangeStart';
export const RANGE_END = 'rangeEnd';
